import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "impersonate flex flex-align-center full-height" }
const _hoisted_2 = { class: "full-width" }
const _hoisted_3 = {
  class: "impersonate__label",
  for: "set-company"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { value: "" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "flex flex-justify-end" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('SET_COMPANY.TITLE')), 1),
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('COMMON.COMPANY')), 1),
      _createElementVNode("select", {
        class: "impersonate__select mb-2",
        id: "set-company",
        value: _ctx.companyId ?? "",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCompanyChange && _ctx.onCompanyChange(...args)))
      }, [
        _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$t('SET_COMPANY.COMPANY_PLACEHOLDER')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyOptions, (company) => {
          return (_openBlock(), _createElementBlock("option", {
            key: company.id,
            value: company.id
          }, _toDisplayString(company.title), 9, _hoisted_6))
        }), 128))
      ], 40, _hoisted_4),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "impersonate__submit",
          type: "button",
          disabled: !_ctx.companyId,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setCompany && _ctx.setCompany(...args)))
        }, _toDisplayString(_ctx.$t('COMMON.NEXT')), 9, _hoisted_8)
      ])
    ])
  ]))
}